/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="82.36"
        height="82.24"
        viewBox="0 0 82.36 82.24"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M81.06 34.5a1.23 1.23 0 0 1 1.24 1.12V81a1.23 1.23 0 0 1-1.12 1.24H1.31a1.25 1.25 0 0 1-1.24-1.12V35.75a1.25 1.25 0 0 1 1.28-1.22 1.23 1.23 0 0 1 1.21 1.09v44.13h77.25v-44a1.25 1.25 0 0 1 1.12-1.25Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M68.75 0a1.23 1.23 0 0 1 1.24 1.12v42.95a1.25 1.25 0 0 1-2.49.13V2.5H14.87v41.57a1.26 1.26 0 0 1-1.12 1.25h-.13a1.25 1.25 0 0 1-1.24-1.12V1.25A1.25 1.25 0 0 1 13.5.01h55.25Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M80.37 34.71a1.25 1.25 0 0 1 1.75.25 1.24 1.24 0 0 1-.25 1.75l-.11.08L41.89 63.5a1.24 1.24 0 0 1-1.26.07l-.13-.07L.62 36.79a1.251 1.251 0 0 1 1.28-2.15l.12.07 39.17 26.23Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M67.76 25.5a1.26 1.26 0 0 1 1.64-.3l.12.08 12.31 9.53a1.251 1.251 0 0 1-1.42 2.06l-.12-.08-12.3-9.54a1.25 1.25 0 0 1-.24-1.74ZM12.85 25.23a1.27 1.27 0 0 1 1.76.23 1.25 1.25 0 0 1-.12 1.65l-.11.09-12.3 9.54a1.251 1.251 0 0 1-1.64-1.89l.1-.09Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M46.21 20.92a8.45 8.45 0 0 0-2.6-.34c-4.51 0-8.15 4.16-8.15 9.18 0 2.26 1 3.82 3.3 3.82 2.94 0 5.72-3.82 6.24-6.94Zm2.78 22a17.71 17.71 0 0 1-9 2.08c-8.32 0-15.43-6.07-15.43-16 0-10.5 7.26-19.5 18.53-19.5 8.84 0 14.74 6.24 14.74 14.74 0 7.62-4.34 12.13-9 12.13-2.08 0-4-1.39-3.81-4.51h-.18c-1.73 3-4.16 4.51-7.1 4.51s-5.55-2.43-5.55-6.41A12.18 12.18 0 0 1 44.31 17.8a14.07 14.07 0 0 1 5.37 1l-1.73 9.19q-1 5.72 1.56 5.72c2.6 0 5.54-3.47 5.54-9.36 0-7.28-4.5-12.48-12.31-12.48-8.32 0-15.42 6.59-15.42 16.81 0 8.5 5.54 13.7 13 13.7a17.05 17.05 0 0 0 7.63-1.73Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'EnvelopeWithAtSymbolPaperIcon';

export default Icon;
